module.exports = __webpack_public_path__ + "static/media/i-dig-you-man.58956cdf.txt";